
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1871',
  depVersions: {
  "customer-portal-app": "static-1.1871",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9550",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.416",
  "growth-payments-core": "static-1.24940",
  "head-dlb": "static-1.4884",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5469",
  "hs-test-utils": "static-1.7884",
  "hub-http": "static-1.6093",
  "hub-http-shared-msw-handlers": "static-1.9656",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17829",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11317",
  "I18n": "static-7.1598",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6344",
  "payment-link-components": "static-1.23137",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6831",
  "quartz-core": "static-1.6050",
  "react": "static-7.182",
  "react-colorpicker": "static-2.10084",
  "react-dlb": "static-1.74",
  "react-utils": "static-2.5242",
  "rich-text-lib": "static-1.19605",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17777",
  "ui-components-test-utils": "static-1.5455",
  "UIComponents": "static-3.8264",
  "foundations-assets": "static-1.4714",
  "foundations-components": "static-1.7663",
  "foundations-theming": "static-1.4284",
  "foundations-theming-specialty": "static-1.2000",
  "framer-motion": "static-1.69",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.377",
  "portals-platform-lib": "static-1.654",
  "quartz-config": "static-1.609",
  "quartz-routing": "static-1.261",
  "quick-fetch": "static-1.3807",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16526",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8019",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.52",
  "ui-addon-draggable": "static-3.4642",
  "ui-addon-react-router-dom": "static-1.9419",
  "usage-tracker": "static-1.7210",
  "usage-tracker-anonymous": "static-1.5627",
  "usage-tracker-core": "static-1.7060",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3301",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3108",
  "quartz-webpack": "static-1.3055",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.79",
  "customer-data-objects": "static-1.7527",
  "frontend-preferences-client": "static-1.7798",
  "laboratory-lib": "static-3.7034",
  "onboarding-scopes": "static-1.6337",
  "rpc-client-utils": "static-1.4518",
  "ui-addon-opt": "static-4.8257",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.2995",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "ts-schema": "static-1.3974",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7554",
  "cssUtils": "static-1.764",
  "customer-data-ui-utilities": "static-1.9698",
  "HubStyle": "static-2.11625",
  "knowledge-content-types": "static-1.8432",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.506",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9761",
  "ui-addon-i18n": "static-1.11020",
  "ui-business-units-lib": "static-1.8909",
  "ui-shepherd-react": "static-3.10020",
  "video-components-external": "static-1.10809",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4199",
  "commerce-tours-lib": "static-1.5845",
  "customer-data-properties": "static-1.51036",
  "getting-started-shared-tasks": "static-1.18092",
  "growth-onboarding-reliability": "static-1.4960",
  "onboarding-tours": "static-1.16371",
  "reference-resolvers-lite": "static-1.7960",
  "sales-checkout-service-client": "static-1.3542",
  "ui-addon-iframeable": "static-1.8922",
  "user-context": "static-1.4974",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4547",
  "icons": "static-2.637",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.506",
  "quartz-head": "static-1.496",
  "quartz-test": "static-1.506",
  "quartz-tracking": "static-1.210",
  "ui-fonts": "static-1.579",
  "usage-tracker-container": "static-1.7200",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9301",
  "data-token-picker": "static-1.16176",
  "FileManagerLib": "static-1.38801",
  "property-translator": "static-1.5282",
  "atom": "static-1.4944",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5615",
  "salesImages": "static-1.522",
  "SharedI18nStrings": "static-1.181",
  "foundations-components-test-utils": "static-1.5146",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.96",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-components": "static-1.3932",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "trellis-assets": "static-1.1429",
  "bend-plugin-foundations-theming": "static-1.2767",
  "foundations-theming-base": "static-1.3269",
  "stylex": "static-1.29",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5624",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4348",
  "react-flip-move": "static-1.67",
  "bender-build-tools": "static-1.3041",
  "inbound-db-properties-service-client": "static-1.3740",
  "superstore": "static-1.4642",
  "chirp-fetch": "static-1.1756",
  "feedback-loader": "static-1.29026",
  "ai-components-ui-library": "static-1.8576",
  "ui-addon-video-player": "static-1.8568",
  "ui-coaching-tips": "static-1.28146",
  "sassPrefix": "static-1.153",
  "react-dnd-compat": "static-1.4493",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2367",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8040",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4525",
  "content-media-composition-data-lib": "static-1.11757",
  "content-media-compositions": "static-2.15764",
  "idb-keyval": "static-1.41",
  "immer": "static-1.33",
  "immerable": "static-1.4027",
  "magpie-lib": "static-1.5468",
  "magpie-types": "static-1.4928",
  "media-bridge-lib": "static-1.18698",
  "video-data-lib": "static-1.34467",
  "commerce-products-lib": "static-1.9056",
  "crm-message-bus": "static-1.42593",
  "growth-data-modal": "static-1.5234",
  "hubspot-apollo-client": "static-1.4753",
  "onboarding-tours-client": "static-1.4585",
  "calling-global-api": "static-1.63964",
  "calling-internal-common": "static-1.31174",
  "calling-lifecycle-internal": "static-1.65346",
  "calling-lifecycle-messages": "static-1.57640",
  "conditional-properties-service-client": "static-1.3692",
  "crm-links": "static-1.6144",
  "customer-data-objects-ui-components": "static-1.12888",
  "customer-data-property-utils": "static-1.7955",
  "external-options-client-types": "static-1.4053",
  "file-manager-components": "static-1.23161",
  "framework-data-schema-resolvers": "static-1.6747",
  "google-libphonenumber": "static-1.35",
  "hs-resources": "static-1.7",
  "inbound-db-meta-service-client": "static-1.3484",
  "inbounddb-objects-service-types": "static-1.4117",
  "meetings-icalendar-utils-lib": "static-1.505",
  "multi-currency-client-types": "static-1.3584",
  "object-builder-ui-client": "static-1.48266",
  "pipeline-validation-client-types": "static-1.3858",
  "property-value-citations": "static-1.1650",
  "pulse": "static-1.405",
  "smart-property-lib": "static-1.6253",
  "tiered-pricing": "static-1.952",
  "ui-addon-form-validation": "static-1.10866",
  "growth-onboarding-confetti": "static-1.2946",
  "growth-onboarding-next-action-utils": "static-1.1499",
  "navigation-components": "static-1.17539",
  "onboarding-tours-utils": "static-1.437",
  "ui-shepherd-tracker": "static-1.7401",
  "ui-universal-auth": "static-1.8795",
  "batch-promise": "static-1.1426",
  "navigation-messaging": "static-1.6866",
  "getting-started-shared-tasks-store": "static-1.17210",
  "hubspotter-http-shared-msw-handlers": "static-1.9654",
  "usage-tracker-session-replay": "static-1.4896",
  "audio-components": "static-1.5717",
  "FileManagerCore": "static-1.38660",
  "FileManagerImages": "static-1.36312",
  "video-components": "static-1.12812",
  "foundations-components-legacy": "static-1.688",
  "growth-monetization-service-types": "static-1.4372",
  "nav-client-types": "static-1.2231",
  "purchase-motions-api": "static-1.5618",
  "self-service-api": "static-1.10116",
  "signup-constants": "static-1.18568",
  "signup-ui-url-generator": "static-2.7910",
  "trials-service-types": "static-1.3773",
  "usage-tracker-public": "static-1.7021",
  "chatspot-core": "static-1.20655",
  "ContentUtils": "static-1.67859",
  "copilot-toolkit": "static-1.10741",
  "growth-onboarding-feedback-components": "static-1.6455",
  "reactive-lib": "static-1.598",
  "simple-logging-lib": "static-1.2924",
  "commerce-permissions": "static-1.638",
  "customer-data-tracking": "static-1.6757",
  "products-iframe-lib": "static-1.7542",
  "products-ui-components-shared-msw-handlers": "static-1.10038",
  "hubspot-apollo-cache": "static-1.212",
  "calling-error-reporting": "static-1.31180",
  "shared-worker-versioning": "static-1.10913",
  "calling-usage-tracker": "static-1.6415",
  "voice-sms-access-library": "static-1.469",
  "conversations-skeleton-state": "static-1.7122",
  "location-customization-utils-lib": "static-1.8796",
  "crm-pipelines-api-client-types": "static-1.4036",
  "framework-builder-read-service-client": "static-1.3902",
  "framework-data-schema-quick-fetch": "static-1.6652",
  "persist-promise": "static-1.3583",
  "directed-graph": "static-1.812",
  "event-emitter": "static-1.821",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5427",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9739",
  "fsm": "static-1.3605",
  "policy-lib": "static-1.6653",
  "react-tinymce": "static-1.54840",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9802",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53966",
  "tinymce-plugins": "static-1.57080",
  "tinymce-themes": "static-1.55936",
  "growth-onboarding-next-action-components": "static-1.1527",
  "user-context-client": "static-1.4486",
  "unified-auth-core-lib": "static-1.590",
  "amplitude-session-replay-browser": "static-1.57",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4406",
  "video-embed": "static-1.35301",
  "content-icons-ui": "static-1.2188",
  "social-insights-client-types": "static-1.21631",
  "eligibility-engine-service-types": "static-1.3054",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4682",
  "integrations-lib": "static-1.15658",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4137",
  "calling-orchestration-schema": "static-1.35246",
  "crm-record-cards-service-types": "static-1.3511",
  "highcharts": "static-8.101",
  "trellis-story-utils": "static-1.4394",
  "storybook-react": "static-1.30",
  "hub-http-contrib": "static-1.2917",
  "interframe": "static-3.4636",
  "tinymce-data": "static-1.40051",
  "ui-addon-sales-email": "static-1.5086",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12191",
  "layout-dnd-utils": "static-1.11166",
  "react-codemirror": "static-1.10498",
  "ui-brand-identity-lib": "static-1.14437",
  "NamespacedHubStyle": "static-2.8963",
  "outpost": "static-1.4072",
  "flux-actions": "static-1.323",
  "integrations-error-boundary-lib": "static-1.13073",
  "integrations-tracking-lib": "static-1.5465",
  "native-integrations-shared-strings": "static-1.7660",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10248",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.309",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67934",
  "layout-data-lib": "static-1.9491",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2875",
  "advanced-menus-core": "static-1.14924",
  "advanced-menus-lib": "static-1.11890",
  "ExportDialog": "static-6.10263",
  "ui-memberships-settings-lib": "static-1.33654",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14923",
  "simple-menus-lib": "static-1.16440"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1871",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9550",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.416",
  "growth-payments-core": "/growth-payments-core/static-1.24940",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5469",
  "hs-test-utils": "/hs-test-utils/static-1.7884",
  "hub-http": "/hub-http/static-1.6093",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9656",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17829",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11317",
  "I18n": "/I18n/static-7.1598",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6344",
  "payment-link-components": "/payment-link-components/static-1.23137",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6831",
  "quartz-core": "/quartz-core/static-1.6050",
  "react": "/react/static-7.182",
  "react-colorpicker": "/react-colorpicker/static-2.10084",
  "react-dlb": "/react-dlb/static-1.74",
  "react-utils": "/react-utils/static-2.5242",
  "rich-text-lib": "/rich-text-lib/static-1.19605",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17777",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5455",
  "UIComponents": "/UIComponents/static-3.8264",
  "foundations-assets": "/foundations-assets/static-1.4714",
  "foundations-components": "/foundations-components/static-1.7663",
  "foundations-theming": "/foundations-theming/static-1.4284",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2000",
  "framer-motion": "/framer-motion/static-1.69",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "portals-platform-lib": "/portals-platform-lib/static-1.654",
  "quartz-config": "/quartz-config/static-1.609",
  "quartz-routing": "/quartz-routing/static-1.261",
  "quick-fetch": "/quick-fetch/static-1.3807",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16526",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8019",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.52",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4642",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9419",
  "usage-tracker": "/usage-tracker/static-1.7210",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7060",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3108",
  "quartz-webpack": "/quartz-webpack/static-1.3055",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.79",
  "customer-data-objects": "/customer-data-objects/static-1.7527",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7798",
  "laboratory-lib": "/laboratory-lib/static-3.7034",
  "onboarding-scopes": "/onboarding-scopes/static-1.6337",
  "rpc-client-utils": "/rpc-client-utils/static-1.4518",
  "ui-addon-opt": "/ui-addon-opt/static-4.8257",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2995",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "ts-schema": "/ts-schema/static-1.3974",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7554",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9698",
  "HubStyle": "/HubStyle/static-2.11625",
  "knowledge-content-types": "/knowledge-content-types/static-1.8432",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.506",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9761",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11020",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8909",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10020",
  "video-components-external": "/video-components-external/static-1.10809",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4199",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5845",
  "customer-data-properties": "/customer-data-properties/static-1.51036",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18092",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4960",
  "onboarding-tours": "/onboarding-tours/static-1.16371",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7960",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3542",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8922",
  "user-context": "/user-context/static-1.4974",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4547",
  "icons": "/icons/static-2.637",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.506",
  "quartz-head": "/quartz-head/static-1.496",
  "quartz-test": "/quartz-test/static-1.506",
  "quartz-tracking": "/quartz-tracking/static-1.210",
  "ui-fonts": "/ui-fonts/static-1.579",
  "usage-tracker-container": "/usage-tracker-container/static-1.7200",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9301",
  "data-token-picker": "/data-token-picker/static-1.16176",
  "FileManagerLib": "/FileManagerLib/static-1.38801",
  "property-translator": "/property-translator/static-1.5282",
  "atom": "/atom/static-1.4944",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5615",
  "salesImages": "/salesImages/static-1.522",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5146",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.96",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3932",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "trellis-assets": "/trellis-assets/static-1.1429",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2767",
  "foundations-theming-base": "/foundations-theming-base/static-1.3269",
  "stylex": "/stylex/static-1.29",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5624",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4348",
  "react-flip-move": "/react-flip-move/static-1.67",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3740",
  "superstore": "/superstore/static-1.4642",
  "chirp-fetch": "/chirp-fetch/static-1.1756",
  "feedback-loader": "/feedback-loader/static-1.29026",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8576",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8568",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28146",
  "sassPrefix": "/sassPrefix/static-1.153",
  "react-dnd-compat": "/react-dnd-compat/static-1.4493",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2367",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8040",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4525",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11757",
  "content-media-compositions": "/content-media-compositions/static-2.15764",
  "idb-keyval": "/idb-keyval/static-1.41",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4027",
  "magpie-lib": "/magpie-lib/static-1.5468",
  "magpie-types": "/magpie-types/static-1.4928",
  "media-bridge-lib": "/media-bridge-lib/static-1.18698",
  "video-data-lib": "/video-data-lib/static-1.34467",
  "commerce-products-lib": "/commerce-products-lib/static-1.9056",
  "crm-message-bus": "/crm-message-bus/static-1.42593",
  "growth-data-modal": "/growth-data-modal/static-1.5234",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4753",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4585",
  "calling-global-api": "/calling-global-api/static-1.63964",
  "calling-internal-common": "/calling-internal-common/static-1.31174",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65346",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57640",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3692",
  "crm-links": "/crm-links/static-1.6144",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12888",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7955",
  "external-options-client-types": "/external-options-client-types/static-1.4053",
  "file-manager-components": "/file-manager-components/static-1.23161",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6747",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-resources": "/hs-resources/static-1.7",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4117",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.505",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3584",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48266",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3858",
  "property-value-citations": "/property-value-citations/static-1.1650",
  "pulse": "/pulse/static-1.405",
  "smart-property-lib": "/smart-property-lib/static-1.6253",
  "tiered-pricing": "/tiered-pricing/static-1.952",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10866",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2946",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1499",
  "navigation-components": "/navigation-components/static-1.17539",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.437",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7401",
  "ui-universal-auth": "/ui-universal-auth/static-1.8795",
  "batch-promise": "/batch-promise/static-1.1426",
  "navigation-messaging": "/navigation-messaging/static-1.6866",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17210",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9654",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4896",
  "audio-components": "/audio-components/static-1.5717",
  "FileManagerCore": "/FileManagerCore/static-1.38660",
  "FileManagerImages": "/FileManagerImages/static-1.36312",
  "video-components": "/video-components/static-1.12812",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.688",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4372",
  "nav-client-types": "/nav-client-types/static-1.2231",
  "purchase-motions-api": "/purchase-motions-api/static-1.5618",
  "self-service-api": "/self-service-api/static-1.10116",
  "signup-constants": "/signup-constants/static-1.18568",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7910",
  "trials-service-types": "/trials-service-types/static-1.3773",
  "usage-tracker-public": "/usage-tracker-public/static-1.7021",
  "chatspot-core": "/chatspot-core/static-1.20655",
  "ContentUtils": "/ContentUtils/static-1.67859",
  "copilot-toolkit": "/copilot-toolkit/static-1.10741",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6455",
  "reactive-lib": "/reactive-lib/static-1.598",
  "simple-logging-lib": "/simple-logging-lib/static-1.2924",
  "commerce-permissions": "/commerce-permissions/static-1.638",
  "customer-data-tracking": "/customer-data-tracking/static-1.6757",
  "products-iframe-lib": "/products-iframe-lib/static-1.7542",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10038",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.212",
  "calling-error-reporting": "/calling-error-reporting/static-1.31180",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10913",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6415",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.469",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7122",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8796",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4036",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3902",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6652",
  "persist-promise": "/persist-promise/static-1.3583",
  "directed-graph": "/directed-graph/static-1.812",
  "event-emitter": "/event-emitter/static-1.821",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5427",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9739",
  "fsm": "/fsm/static-1.3605",
  "policy-lib": "/policy-lib/static-1.6653",
  "react-tinymce": "/react-tinymce/static-1.54840",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9802",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53966",
  "tinymce-plugins": "/tinymce-plugins/static-1.57080",
  "tinymce-themes": "/tinymce-themes/static-1.55936",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1527",
  "user-context-client": "/user-context-client/static-1.4486",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.590",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4406",
  "video-embed": "/video-embed/static-1.35301",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "social-insights-client-types": "/social-insights-client-types/static-1.21631",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3054",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4682",
  "integrations-lib": "/integrations-lib/static-1.15658",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4137",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35246",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3511",
  "highcharts": "/highcharts/static-8.101",
  "trellis-story-utils": "/trellis-story-utils/static-1.4394",
  "storybook-react": "/storybook-react/static-1.30",
  "hub-http-contrib": "/hub-http-contrib/static-1.2917",
  "interframe": "/interframe/static-3.4636",
  "tinymce-data": "/tinymce-data/static-1.40051",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5086",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12191",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11166",
  "react-codemirror": "/react-codemirror/static-1.10498",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14437",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8963",
  "outpost": "/outpost/static-1.4072",
  "flux-actions": "/flux-actions/static-1.323",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13073",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5465",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7660",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10248",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.309",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67934",
  "layout-data-lib": "/layout-data-lib/static-1.9491",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2875",
  "advanced-menus-core": "/advanced-menus-core/static-1.14924",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11890",
  "ExportDialog": "/ExportDialog/static-6.10263",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33654",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14923",
  "simple-menus-lib": "/simple-menus-lib/static-1.16440"
}
};
